<template>
  <div class="min-h-screen bg-off-black">
    <div class="container mx-auto px-4 py-16">
      <!-- Hero Section -->
      <div class="text-center mb-16">
        <h1 class="text-5xl md:text-6xl font-serif font-semibold mb-6 text-vibe-green">
          Smart Onboarding for US Professionals
        </h1>
        <p class="text-xl md:text-2xl text-gray-green max-w-3xl mx-auto">
          Streamline AML compliance and client onboarding with AI-powered solutions designed for legal and accounting professionals operating in the United States
        </p>
      </div>

      <!-- Freebie Cards Section -->
      <div class="max-w-3xl mx-auto">
        <h2 class="text-3xl md:text-4xl font-serif font-semibold text-white text-center mb-12">
          Free Resource
        </h2>

        <div class="max-w-lg mx-auto">
          <!-- US AML Checklist Card -->
          <div class="bg-green-700 rounded-lg overflow-hidden shadow-xl border border-vibe-green hover:border-vibe-green transition-all duration-300 hover:transform hover:scale-105 relative">
            <div class="absolute top-4 right-4 bg-vibe-green text-black text-xs font-bold px-3 py-1 rounded-full">
              NEW
            </div>
            <div class="p-8">
              <div class="bg-vibe-green rounded-full w-16 h-16 flex items-center justify-center mb-6">
                <svg class="w-8 h-8 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
              </div>

              <h3 class="text-2xl font-semibold text-vibe-green mb-4">
                2026 AML Compliance Checklist
              </h3>

              <p class="text-gray-green mb-6 leading-relaxed">
                Comprehensive AML compliance checklist for US firms navigating the latest 2026 regulatory requirements.
              </p>

              <ul class="text-sm text-gray-green mb-6 space-y-2">
                <li class="flex items-start">
                  <span class="text-vibe-green mr-2">✓</span>
                  <span>AML compliance framework</span>
                </li>
                <li class="flex items-start">
                  <span class="text-vibe-green mr-2">✓</span>
                  <span>BSA/CDD requirements</span>
                </li>
                <li class="flex items-start">
                  <span class="text-vibe-green mr-2">✓</span>
                  <span>Beneficial ownership verification</span>
                </li>
                <li class="flex items-start">
                  <span class="text-vibe-green mr-2">✓</span>
                  <span>Practical implementation guidance</span>
                </li>
              </ul>

              <router-link
                to="/us/aml-checklist"
                class="btn-primary w-full text-center inline-block"
              >
                Download Free Checklist
              </router-link>
            </div>
          </div>
        </div>
      </div>

      <!-- CTA Section -->
      <div class="max-w-4xl mx-auto mt-20 bg-green-600 rounded-lg p-12 text-center border border-vibe-green">
        <h2 class="text-3xl md:text-4xl font-serif font-semibold text-vibe-green mb-6">
          Ready to Automate Your Onboarding?
        </h2>
        <p class="text-lg text-white mb-8">
          See how Marker AI can help you streamline workflows, strengthen compliance, and accelerate commercial momentum. Book a demo to learn more.
        </p>
        <a
          href="https://www.marker-ai.com/contact-us"
          class="btn-primary text-lg"
        >
          Get in Touch
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'USHub',
};
</script>
